// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

  
export const loginSuperAdminAPI = async (loginData) => {
  try {
    // POST request to your login endpoint with loginData as the body
    const response = await axios.post(`${API_BASE_URL}/auth/superadminlogin`, loginData, {
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
    });
    
    // Extract data from response
    const data = response.data;

    // Check statusCode and return appropriate response
    if (data.statusCode === 1003) {
      return { error: data.result };  // Return specific error for user already exists or invalid credentials
    } else if (data.statusCode === 1001) {
      localStorage.setItem('token', data.result);  // Store JWT token in localStorage
      localStorage.setItem('userNAME', data.result.userDetails.userName);
      localStorage.setItem('clientID', data.result.userDetails.clientId);
      localStorage.setItem('userID', data.result.userDetails.userId); // Store userId
      localStorage.setItem('roleID', data.result.userDetails.roleId); // Store username
      const menudata = await fetchMenusByClientIdAndRoleId(data.result.userDetails.clientId,data.result.userDetails.roleId);
      if(!menudata.err){
        localStorage.setItem('userMENUS', menudata.success);
        if(!menudata.success.length>0){
          logout();
          return { error: 'No Menus Available' };
        }
      }else{
        return { error: 'Login Failed By Menus' };
      }
      return { success: 'Successfully Logged In' };
    } else {
      return { error: 'Login Failed' };
    }
  } catch (error) {
    console.error('Error in loginAPI:', error);
    return { error: 'An error occurred while logging in' };  // Handle other unexpected errors
  }
};

export const loginAPI = async (loginData) => {
  try {
    // POST request to your login endpoint with loginData as the body
    const response = await axios.post(`${API_BASE_URL}/auth/login`, loginData, {
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
    });
    
    // Extract data from response
    const data = response.data;

    // Check statusCode and return appropriate response
    if (data.statusCode === 1003) {
      return { error: data.result };  // Return specific error for user already exists or invalid credentials
    }else if (data.statusCode === 1005) {
      return { error: data.result };  // Return specific error for user already exists or invalid credentials
    } else if (data.statusCode === 1001) {
      localStorage.setItem('token', data.result);  // Store JWT token in localStorage
      localStorage.setItem('userNAME', data.result.userName);
      localStorage.setItem('clientID', data.result.clientId);
      localStorage.setItem('userID', data.result.userId); // Store userId
      localStorage.setItem('roleID', data.result.roleId); // Store username
      const menudata = await fetchMenusByClientIdAndRoleId(data.result.clientId,data.result.roleId);
      if(!menudata.err){
        localStorage.setItem('userMENUS', menudata.success);
        if(menudata.success === '[]' || !menudata.success.length>0 ){
          logout();
          return { error: 'No Menus Available' };
        }
      }else{
        return { error: 'Login Failed By Menus' };
      }
      return { success: 'Successfully Logged In' };
    } else {
      return { error: 'Login Failed' };
    }
  } catch (error) {
    console.error('Error in loginAPI:', error);
    return { error: 'An error occurred while logging in' };  // Handle other unexpected errors
  }
};

export const logout = async () => {
  try {
  localStorage.removeItem('token');
  localStorage.removeItem('userNAME');
  localStorage.removeItem('clientID');
  localStorage.removeItem('userID'); // Store userId
  localStorage.removeItem('roleID'); // Store username
  localStorage.removeItem('userMENUS');
  return { success: 'Successfully Logged In' };
} catch (error) {
  console.error('Error in loginout:', error);
  return { error: 'An error occurred while logging out' };  // Handle other unexpected errors
}
};

export const fetchMenusByClientIdAndRoleId = async (clientId,roleId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/menus/getuserMenusList/${clientId}/${roleId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    

    const data =  response.data;
    // Check for specific status codes in the response
    if (data.statusCode === 1006) {
      // Returning a specific error message if the user already exists
      return { error:  data.result  };
    }else if(data.statusCode===1001){
      return { success: JSON.stringify(data.result) };
    }else{
      return { error: 'Fail' };
    } // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


export const registerUser = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/client/save`, {
      method: 'POST',
      headers: {
        'auth_key': `${getAuthKey()}`,
        'Content-Type': 'application/json',
        //'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.status === "300") {
      // Returning a specific error message if the user already exists
      return { error: 'User already exists' };
    }else if(data.status==="200"){
      return { success: 'Added Successfully' };
    }else{
      return { error: 'Fail' };
    }
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


// Fetch all countries from the API
export const fetchClientData = async () => {
  try {
    const clientId = localStorage.getItem('clientID');
    const response = await axios.get(`${API_BASE_URL}/admin/client/getclientslist/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Clients:', error);
    alert('Error fetching Clients:'+ error);
    throw error;
  }
};

// Fetch all countries from the API
export const fetchClientDataById = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/client/getClientInformation/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateClient = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/client/updateclient`, {
      method: 'POST',
      headers: {
        'auth_key': `${getAuthKey()}`,
        'Content-Type': 'application/json',
        //'Authorization': `Bearer ${getAuthToken()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();// Check for specific status codes in the response
    if (data.status === "300") {
      // Returning a specific error message if the user already exists
      return { error: 'Client already exists' };
    }else if(data.status==="200"){
      return { success: 'Updated Successfully' };
    }else{
      return { error: 'Fail' };
    }
    alert(data);
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

